import { render, staticRenderFns } from "./PourcentageStatTag.vue?vue&type=template&id=7cfd3930&lang=html&"
import script from "./PourcentageStatTag.vue?vue&type=script&lang=js&"
export * from "./PourcentageStatTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PourcentageStatTag.vue"
export default component.exports